/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_ac5b3318{position:relative}.root_ac5b3318.snap_ac5b3318{position:absolute;top:0;left:0;right:0;bottom:0}.dragOver_ac5b3318:after{content:' ';display:block;pointer-events:none;border:2px solid "},{"theme":"neutralTertiaryAlt","defaultValue":"#c8c8c8"},{"rawString":";position:absolute;top:0;left:0;bottom:0;right:0}\n"}]);
export const root = "root_ac5b3318";
export const snap = "snap_ac5b3318";
export const dragOver = "dragOver_ac5b3318";